import { render, staticRenderFns } from "./brandMoney.vue?vue&type=template&id=51a695e2"
import script from "./brandMoney.vue?vue&type=script&lang=js"
export * from "./brandMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports